app.ClonableUser = app.AbstractModel.extend({
  ModelName: 'user',
  Schema: {
    displayName: 'user',
  },

  displayName() {
    const fullName = [this.get('firstName'), this.get('lastName')].filter(Boolean).join(' ').trim();
    const name = fullName || this.get('username');
    const roleName = this.get('roleName');
    let label = roleName ? `${name} (${roleName})` : name;
    if (this.get('isApiToken')) {
      const rightNames = this.get('apiTokenRightNames') || [];
      label += rightNames.length ? ` [API Token: ${rightNames.join(', ')}]` : ' [API Token]';
    }
    if (!this.get('registered')) {
      label += ' [Unregistered]';
    } else if (this.get('disabled')) {
      label += ' [Suspended]';
    }
    return label;
  },
});
